import React from 'react'
import { SubTabBarWrapper, SubTabItem } from '../HrAnalytics.styled'

interface SubTab {
  key: string
  label: string
}

interface ISubTabBar {
  tabs: SubTab[]
  activeTab: string
  onTabChange: (key: string) => void
}

export const SubTabBar = ({ tabs, activeTab, onTabChange }: ISubTabBar) => {
  return (
    <SubTabBarWrapper>
      {tabs.map((tab) => (
        <SubTabItem
          key={tab.key}
          active={activeTab === tab.key}
          onClick={() => onTabChange(tab.key)}
        >
          {tab.label}
        </SubTabItem>
      ))}
    </SubTabBarWrapper>
  )
}
